import merge from 'deepmerge';
import { Theme } from '@cvent/carina/types/theme';
import { FinalizedWaxColorPalette } from './types';

export default function commonOverrides(
  theme: Theme,
  waxPalette: FinalizedWaxColorPalette['default'] | FinalizedWaxColorPalette['dark']
): Theme {
  const click = {
    base: waxPalette.secondary.seedColor,
    hover: waxPalette.secondary.adjusted1,
    active: waxPalette.secondary.adjusted2,
    disabled: waxPalette.secondary.stack['45']
  };
  return merge(theme, {
    backgroundColor: {
      click,
      clickHard: click,
      clickSoft: {
        hover: waxPalette.secondary.stack['10'],
        active: waxPalette.secondary.stack['15']
      },
      interactive: {
        fill: {
          base: waxPalette.secondary.seedColor,
          hover: waxPalette.secondary.adjusted1,
          active: waxPalette.secondary.adjusted2
        }
      },
      brand: {
        fill: {
          base: waxPalette.primary.seedColor,
          hover: waxPalette.primary.adjusted1,
          active: waxPalette.primary.adjusted2
        }
      },
      accent: {
        fill: {
          base: waxPalette.primary.seedColor,
          surface: waxPalette.primary.seedColor
        }
      },
      tertiary: {
        fill: {
          base: waxPalette.primary.seedColor
        }
      }
    },

    borderColor: {
      interactive: {
        base: waxPalette.secondary.seedColor
      },
      brand: {
        base: waxPalette.secondary.seedColor
      },
      accent: {
        base: waxPalette.primary.seedColor
      },
      tertiary: {
        base: waxPalette.primary.seedColor
      },
      hover: waxPalette.secondary.seedColor
    },

    font: {
      color: {
        interactive: {
          base: waxPalette.secondary.seedColor
        },
        brand: {
          hover: waxPalette.secondary.seedColor
        },
        accent: {
          base: waxPalette.primary.seedColor
        },
        tertiary: {
          base: waxPalette.primary.seedColor
        }
      }
    }
  });
}
